/** AIAgentScheduleExecutionMode — `AIAgentSchedule.executionMode`. */
export default Object.freeze({
  ManualOnly: 1,
  Recurring: 2,
});
